import theme from '../Theme/Theme';

const styles = () => ({
  favoriteIcon: {
    color: theme.colors.lightText2,
    width: '24px',
    height: '24px',
  },
  activeFavoriteIcon: {
    color: theme.colors.error,
    width: '24px',
    height: '24px',
  },
});

export default styles;
